import React, { useState } from 'react';
import { Plus, Trash2, Edit2, Save, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { adminApi, API_ENDPOINTS } from './api';
import { ImageUploader } from './ImageUploader';

const GalleryForm = ({ item, onSave, onCancel }) => {
  const [f, setF] = useState({
    title: item?.title || '', description: item?.description || '',
    image_url: item?.image_url || '', category: item?.category || '',
  });
  const up = (k, v) => setF(p => ({ ...p, [k]: v }));
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-6 mb-5">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-bold text-gray-900">{item ? "Modifier" : "Nouvelle photo"}</h3>
        <button onClick={onCancel}><X className="w-5 h-5 text-gray-400" /></button>
      </div>
      <form onSubmit={e => { e.preventDefault(); onSave(f); }} className="space-y-3">
        <div><Label className="text-xs text-gray-500">Titre *</Label><Input value={f.title} onChange={e => up('title', e.target.value)} required className="h-9" /></div>
        <ImageUploader value={f.image_url} onChange={v => up('image_url', v)} label="Photo" />
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-xs text-gray-500">Categorie</Label><Input value={f.category} onChange={e => up('category', e.target.value)} className="h-9" /></div>
          <div><Label className="text-xs text-gray-500">Description</Label><Input value={f.description} onChange={e => up('description', e.target.value)} className="h-9" /></div>
        </div>
        <div className="flex gap-2">
          <Button type="submit" className="bg-gray-900 hover:bg-gray-800 h-9 rounded-lg text-sm"><Save className="w-4 h-4 mr-1.5" />Sauvegarder</Button>
          <Button type="button" variant="outline" onClick={onCancel} className="h-9 rounded-lg text-sm">Annuler</Button>
        </div>
      </form>
    </div>
  );
};

export const GalleryTab = ({ gallery, onReload, onReloadStats }) => {
  const [edit, setEdit] = useState(null);
  const [form, setForm] = useState(false);

  const reset = () => { setEdit(null); setForm(false); };
  const open = (item = null) => { setEdit(item); setForm(true); };

  const saveGallery = async (d) => {
    try {
      if (edit) await adminApi.put(API_ENDPOINTS.adminGalleryId(edit.id), d);
      else await adminApi.post(API_ENDPOINTS.adminGallery, d);
      toast.success('OK');
      reset();
      onReload();
      onReloadStats();
    } catch (err) {
      console.error('Save gallery failed:', err);
      toast.error('Erreur lors de la sauvegarde');
    }
  };

  const delGallery = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    try {
      await adminApi.del(API_ENDPOINTS.adminGalleryId(id));
      toast.success('Supprime');
      onReload();
      onReloadStats();
    } catch (err) {
      console.error('Delete gallery image failed:', err);
      toast.error('Erreur lors de la suppression');
    }
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Galerie</h1>
          <p className="text-sm text-gray-500">{gallery.length} photos</p>
        </div>
        <Button onClick={() => open()} className="bg-gray-900 hover:bg-gray-800 text-sm h-9 rounded-lg">
          <Plus className="w-4 h-4 mr-1.5" />Ajouter
        </Button>
      </div>
      {form && <GalleryForm item={edit} onSave={saveGallery} onCancel={reset} />}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {gallery.map(img => (
          <div key={img.id} className="bg-white rounded-xl border border-gray-100 overflow-hidden group">
            <div className="relative aspect-square">
              <img src={img.image_url} alt="" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                <button onClick={() => open(img)} className="p-2 bg-white rounded-lg"><Edit2 className="w-3.5 h-3.5" /></button>
                <button onClick={() => delGallery(img.id)} className="p-2 bg-white rounded-lg"><Trash2 className="w-3.5 h-3.5 text-red-500" /></button>
              </div>
            </div>
            <div className="p-2">
              <p className="text-xs font-medium truncate text-gray-700">{img.title}</p>
              <p className="text-[10px] text-gray-400">{img.category}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
